module.exports = __webpack_public_path__ + "img/pantalla-6-1.021c1b46.png";